import Layout from "partials/layout";
import img1 from "../../assets/images/footerImg/instructorHero.svg";
import React, { useState } from "react";

import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import DetailsBox from "components/detailsbox";
import icon1 from "../../assets/images/footerImg/icon1.svg";
import icon2 from "../../assets/images/footerImg/icon2.svg";
import icon3 from "../../assets/images/footerImg/icon3.svg";
import split1 from "../../assets/images/footerImg/split1.svg";
import split2 from "../../assets/images/footerImg/split2.svg";
import womanImg from "../../assets/images/footerImg/womanImg.svg"
import { FiUsers } from "react-icons/fi";
import { LuBadgeCheck } from "react-icons/lu";
import { BiWorld } from "react-icons/bi";
import { GrNotes } from "react-icons/gr";
import { RiStackLine } from "react-icons/ri";
import { FaPlay } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa6";
import { FaLongArrowAltLeft } from "react-icons/fa";
import { ERCButton } from "components/button";
import CountUp from "react-countup";

export const BeInstructor = () => {
  const reviews = [
    {
      id: 1,
      title: "Great Product!",
      content:
        "Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra.",
      author: "John Doe",
    },
    {
      id: 2,
      title: "Amazing Experience",
      content:
        "Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra.",
      author: "Jane Smith",
    },
    {
      id: 3,
      title: "Highly Satisfied",
      content:
        "Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra",
      author: "Sam Wilson",
    },
  ];

  const whyData = [
    {
      id: 1,
      head: "Teach Student at a nice pace",
      text: "Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.",
    },
    {
      id: 2,
      head: "Teach Student at a nice pace",
      text: "Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.",
    },
    {
      id: 3,
      head: "Teach Student at a nice pace",
      text: "Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.",
    },
  ];
  const howData = [
    {
      id: 1,
      label: "Apply to become instructor.",
      desc: "Sed et mattis urna. Sed tempus fermentum est, eu lobortis nibh consequat eu. Nullam vel libero pharetra.",
      img: icon1,
    },
    {
      id: 2,
      label: "Apply to become instructor.",
      desc: "Sed et mattis urna. Sed tempus fermentum est, eu lobortis nibh consequat eu. Nullam vel libero pharetra.",
      img: icon2,
    },
    {
      id: 3,
      label: "Apply to become instructor.",
      desc: "Sed et mattis urna. Sed tempus fermentum est, eu lobortis nibh consequat eu. Nullam vel libero pharetra.",
      img: icon3,
    },
    {
      id: 4,
      label: "Apply to become instructor.",
      desc: "Sed et mattis urna. Sed tempus fermentum est, eu lobortis nibh consequat eu. Nullam vel libero pharetra.",
      img: icon1,
    },
    {
      id: 5,
      label: "Apply to become instructor.",
      desc: "Sed et mattis urna. Sed tempus fermentum est, eu lobortis nibh consequat eu. Nullam vel libero pharetra.",
      img: icon2,
    },
    {
      id: 6,
      label: "Apply to become instructor.",
      desc: "Sed et mattis urna. Sed tempus fermentum est, eu lobortis nibh consequat eu. Nullam vel libero pharetra.",
      img: icon3,
    },
  ];
  const ratings =[
    {
      id:1,
      icon: <FiUsers className="text-[#FF6636] w-10 h-10" />,
      label:"Students",
      rate:800000,
    },
    {
      id:2,
      icon: <GrNotes className="text-[#564FFD] w-10 h-10" />,
      label:"Interactive Content",
      rate:700000,
    },
    {
      id:3,
      icon: <FaPlay className="text-secondary w-10 h-10" />,
      label:"Learning Videos",
      rate:99.9,
    },
    {
      id:4,
      icon: <RiStackLine className="text-[#FD8E1F] w-10 h-10" />,
      label:"Mock Questions",
      rate:900,
    },
  ]
 const navigate = useNavigate()
  const [currentReview, setCurrentReview] = useState(0);

  const nextReview = () => {
    if (currentReview < reviews.length - 1) {
      setCurrentReview(currentReview + 1);
    }
  };

  const prevReview = () => {
    if (currentReview > 0) {
      setCurrentReview(currentReview - 1);
    }
  };
  return (
    <Layout mqcolor="#00296b">
      <section className="lg:px-36 md:px-24 px-6 flex md:flex-row  md:items-center flex-col  bg-white gap-6 pb-12 pt-12">
        <div className="md:w-1/2 w-full flex flex-col gap-8 ">
          <h1 className="md:text-[56px] md:leading-[72px] text-black font-ManropeBold">
            Become an Instuctor
          </h1>
          <p className="text-neutral md:text-[28px] md:leading-[40px]">
            Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
            vulputate libero et velit interdum, ac aliquet odio mattis. Class
            aptent taciti sociosqu ad litora torquent per conubia nostra,
          </p>
          <div>
            <ERCButton
              weight={"700"}
              g={"8px"}
              size="16px"
              p={"16px 24px"}
              color="#00296B"
              bgcolor="#FFD600"
              lHeight="24px"
              width="184px"
              showArrow
              onClick={() => {
                window.scrollTo(0, 0);
                navigate("/");
              }}
            >
              Get Started
            </ERCButton>
          </div>
        </div>

        <div className="md:w-1/2 w-full">
          <img src={img1} alt="img1" className="object-cover" />
        </div>
      </section>
      {/* section 2 */}
      <section className="bg-[#FEFEDE] w-full">
      <main className="md:px-96 px-6 flex md:flex-row w-full md:justify-between gap-6 py-12 items-center flex-col">
  {
    ratings.map((rating) => (
      <div className="flex gap-4" key={rating.id}>
        {rating.icon}
        <div className="flex flex-col font-inter gap-4 text-[#1D2026]">
          <h2 className="text-[32px] font-semibold leading-8">
            {rating.label === 'Learning Videos' ? (
              // Handle percentage case
              <CountUp
                delay={0.5}
                end={rating.rate}
                decimals={1}
                suffix="%"
              />
            ) : (
              // Handle the number formatting case for K
              <CountUp
                delay={0.5}
                end={rating.rate}
                formattingFn={(value) => value >= 1000 ? (value / 1000).toFixed(0) + 'K' : value}
              />
            )}
            
          </h2>
          <p className="text-[#4E5566] font-medium text-[14px] leading-5">{rating.label}</p>
        </div>
      </div>
    ))
  }
</main>


      </section>
      {/* section 3 */}
      <section className="md:px-24 px-6 flex md:flex-row text-[#1D2026]  md:items-start flex-col  bg-white gap-12 pb-12 pt-24">
        <div className="md:w-1/2 w-full">
          <img src={womanImg} alt="img1" className="object-cover" />
        </div>

        <div className="md:w-1/2 w-full flex flex-col gap-8 ">
          <h1 className="md:text-[40px] text-[24px] md:leading-[48px] text-[#1D2026] font-ManropeBold">
            Why you'll start teaching on ERC
          </h1>
          <p className="text-neutral font-ManropeLight md:text-[18px] md:leading-[20px]">
            Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
            vulputate libero et velit interdum, ac aliquet odio mattis. Qorem
            ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate
            libero et velit interdum, ac aliquet odio mattis.
          </p>
          <div className="flex flex-col gap-6">
          {whyData.map((data) => (
            <div className="flex gap-4" key={data.id}>
              <Icon
                icon="lets-icons:check-fill"
                className="text-[#23BD33] w-10 h-10"
              ></Icon>
              <div className="flex flex-col gap-2">
                <h1 className="font-ManropeBold md:text-[18px] leading-5">
                  {data.head}
                </h1>
                <p className="text-[14px] text-[#525252] font-ManropeLight leading-5">
                  {data.text}
                </p>
              </div>
            </div>
          ))}
        </div>
        </div>
        
      </section>
      {/* section 4 */}
      <section className="bg-secondary py-12">
        <main className="lg:px-56 md:px-24 px-6 text-[#1D2026]  ">
          <h1 className="md:text-[40px] text-[24px]  py-6 md:leading-[48px] text-center text-white font-ManropeBold">
            How you'll become a successful instructor
          </h1>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1  gap-6">
            {howData.map((data) => (
              <div className="flex flex-col p-6 gap-4 items-center font-inter bg-white ">
                <img src={data.img} alt="" />
                <div className="flex font-medium leading-6 ">
                  {data.id}. {data.label}
                </div>
                <p className="text-center text-[#6E7485] text-[14px] leading-[22px] ">
                  {data.desc}
                </p>
              </div>
            ))}
          </div>
        </main>
      </section>
      {/* section 5 */}
      <section className="md:px-24 px-6 flex md:flex-row text-[#1D2026]  md:items-center flex-col  bg-white md:gap-24 gap-6 pb-12 pt-24">
        <div className="md:w-1/2 w-full">
          <img src={split1} alt="img1" className="object-cover" />
        </div>
        <div className="md:w-1/2 w-full flex flex-col gap-8 ">
          <h1 className="md:text-[40px] font-inter font-semibold md:leading-[48px] text-[28px]  text-[#1D2026] font-ManropeBold">
            Instructor rules & regulations
          </h1>
          <p className="text-[#000000] font-ManropeLight md:text-[20px] md:leading-6">
            Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
            vulputate libero et velit interdum, ac aliquet odio mattis. Class
            aptent taciti sociosqu ad litora torquent per conubia nostra
          </p>
          <ul className="flex flex-col gap-6 pl-6  font-inter md:text-[16px] ">
            <li className="list-disc">Qorem ipsum dolor sit amet</li>
            <li className="list-disc">Qorem ipsum dolor sit amet</li>
            <li className="list-disc">Qorem ipsum dolor sit amet</li>
          </ul>
        </div>
      </section>
      {/* section 6 */}
      <section className="bg-[#FEFEDE]">
        <main className="md:px-24 px-6 flex md:flex-row text-[#1D2026]  md:items-start flex-col  bg-white md:gap-24 gap-6 pb-12 pt-24">
          <div className="md:w-1/2 w-full flex flex-col gap-8 ">
            <h1 className="md:text-[40px] text-[24px]  font-inter font-semibold md:leading-[48px] text-[#1D2026] font-ManropeBold">
              20k+ Instructor created their success story with eduguard
            </h1>
            <p className="text-[#000000] font-ManropeLight md:text-[20px] md:leading-6">
              Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
              vulputate libero et velit interdum, ac aliquet odio mattis. Class
              aptent taciti sociosqu ad litora torquent per conubia nostra,
            </p>
            <div className="max-w-full  p-6 bg-secondary flex flex-col gap-2 ">
              <p className=" text-[#FFFFFF] font-ManropeLight md:text-[20px] md:leading-6">
                {reviews[currentReview].content}
              </p>
            </div>
            <div className="flex gap-2 mt-6">
              <button
                className={`px-4 py-2 rounded ${
                  currentReview === 0
                    ? "bg-[#F5F7FA] cursor-not-allowed text-black"
                    : "bg-gray-500 hover:bg-gray-600"
                } text-black`}
                onClick={prevReview}
                disabled={currentReview === 0}
              >
                <FaLongArrowAltLeft />
              </button>

              <button
                className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-black rounded"
                onClick={nextReview}
                disabled={currentReview === reviews.length - 1}
              >
                <FaArrowRight />
              </button>
            </div>
          </div>
          <div className="md:w-1/2 w-full">
            <img src={split2} alt="img1" className="object-cover" />
          </div>
        </main>
      </section>
    </Layout>
  );
};
